import React, { useState } from 'react';
import { Modal, Button, message, Popconfirm } from 'antd';
import { actualizarEstatusSolicitud, admitirSubscripcion } from '../../../services/subscripciones';
import {
    solicitudSusbcripcionCode,
  } from "../../../utils/enums/calendario";

const SolicitudesModal = ({ visible, solicitudes, handleModalSolicitudesCancel, actualizarInformacion }) => {

async function handleAceptarSolicitud(solicitud) {
    try {
        const dataToSend = {
            solicitudId: solicitud.id
        };
        var respuesta = await admitirSubscripcion(dataToSend);
        if (respuesta.data === true)
            message.success("Solicitud de subscripcion aceptada exitosamente.");
            actualizarInformacion();
    } catch (error) {
        console.error("Error admitiendo subscripcion:", error);
        messag.error(
            "Error admitiendo subscripcion. Por favor, inténtelo de nuevo más tarde."
        );
    }
}

const handleRechazarSolicitud = async (solicitud) => {
    try {
        const dataToSend = {
        id: solicitud.id,
        estatus: solicitudSusbcripcionCode.Anulada.value,
        };
        var respuesta = await actualizarEstatusSolicitud(dataToSend);
        if (respuesta.data === true)
        message.success("Solicitud de subscripcion rechazada exitosamente.");
        actualizarInformacion();
    } catch (error) {
        console.error("Error actualizando estatus solicitud:", error);
        message.error(
        "Error actualizando estatus solicitud. Por favor, inténtelo de nuevo más tarde."
        );
    }
}

  return (
    <Modal
      title="Solicitudes de subscripcion"
      visible={visible}
      onCancel={handleModalSolicitudesCancel}
      footer={[
        <Button key="cancel" onClick={handleModalSolicitudesCancel}>
          Cerrar
        </Button>
      ]}
      centered
    >
     <ul style={{ listStyle: 'none', padding: 0, marginTop: '20px' }}>
        {solicitudes && solicitudes.length > 0 ? (
            solicitudes.map((solicitud, index) => (
            <li key={solicitud.UsuarioId}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginRight: '10px', marginTop: '10px' }}>{solicitud.gestor}</p>
                <div style={{ marginLeft: '140px' }}>
                    <Popconfirm
                    title="¿Está seguro de que desea aceptar esta solicitud?"
                    onConfirm={() => handleAceptarSolicitud(solicitud)}
                    okText="Sí"
                    cancelText="Cancelar"
                    >
                    <Button type="primary" style={{ marginRight: '10px' }}>Aceptar</Button>
                    </Popconfirm>
                    <Popconfirm
                    title="¿Está seguro de que desea rechazar esta solicitud?"
                    onConfirm={() => handleRechazarSolicitud(solicitud)}
                    okText="Sí"
                    cancelText="Cancelar"
                    >
                    <Button danger>Rechazar</Button>
                    </Popconfirm>
                </div>
                </div>
            </li>
            ))
        ) : (
            <p>Usted no presenta solicitudes pendientes.</p>
        )}
        </ul>
    </Modal>
  );
};

export default SolicitudesModal;